module.exports = "/static/assets/7d5856cb1fc9aba2ec4134627375dffc.png";